(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/NestedModel', 'app/urls'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('backbone-torso/modules/NestedModel'), require('./../urls'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoNestedModel, urls) {
  'use strict';

  /**
   * Model representing a tablet
   * idAttribute as name
   * @class TabletModel
   * @constructor
   * @extends Torso.NestedModel
   */
  return TorsoNestedModel.extend({
    urlRoot: urls.tabletExtService
  });
}));
